import React, {useEffect} from 'react';
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import {ArrowDropDown} from "@mui/icons-material";
import {
    competitionRegistrationStatusColor,
    competitionRegistrationStatusLabel,
    eventStatus
} from "../../util/standards-util";
import Box from "@mui/material/Box";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import {useUpdateCompetitionRegistrationMutation} from "../../slices/apiSlice";
import {useNavigate} from "react-router-dom";


const statusOptions = {
    planned:[0x10,0x30,0x401],
    active:[0x40,0x401],
}

const getStatusOptions = (status) => {
    switch(status) {
        case eventStatus.STATUS_PLANNED:
        case eventStatus.STATUS_PLANNED_REGISTRATION_CLOSED:
            return statusOptions.planned
        case eventStatus.STATUS_ACTIVE:
            return statusOptions.active
        default:
            return []
    }
}


const RegistrationStatusWidget = ({ entry, event, onUpdate }) => {

    const [registration, setRegistration] = React.useState(entry.registration)
    const [menuAnchorEl, setMenuAnchorEl] = React.useState(null);
    const menuOpen = Boolean(menuAnchorEl);

    const [update, updateResult] =useUpdateCompetitionRegistrationMutation()

    const handleMenuClose = (e) => {
        setMenuAnchorEl(null);
    }

    const handleChangeStatus = (e, u) => {
        handleMenuClose(e)

        update({
            eventId: event.id,
            id: registration.i,
            status: u,
        })
    }

    const handleClicked = (e) => {
        e.stopPropagation()
        setMenuAnchorEl(e.currentTarget);
    }

    useEffect(() => {
        if (updateResult.isSuccess){
            if (onUpdate && updateResult.data.status === "ok") onUpdate(updateResult.data.data)

            setRegistration(updateResult.data.data)
        }
    }, [updateResult]);

    return (
        <Box sx={{display:'flex',alignItems:'center'}}>
            <Typography variant={'body1'} mr={1}>Status:</Typography>
            <Button
                variant={'contained'}
                endIcon={<ArrowDropDown/>}
                color={competitionRegistrationStatusColor[registration.u]}
                size={'small'}
                onClick={handleClicked}
            >
                {competitionRegistrationStatusLabel[registration.u]}
            </Button>
            <Menu
                anchorEl={menuAnchorEl}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
                open={menuOpen}
                onClose={handleMenuClose}
            >
                {getStatusOptions(event.status).map(u=>{
                    return <MenuItem key={u} onClick={(e)=>{handleChangeStatus(e,u)}}>
                        {competitionRegistrationStatusLabel[u]}
                    </MenuItem>
                })}
            </Menu>
        </Box>
    )
}

export default RegistrationStatusWidget;